import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const AppleIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 18"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M12.644 9.51c-.008-1.474.66-2.587 2.01-3.407-.756-1.08-1.897-1.675-3.404-1.792-1.426-.112-2.985.832-3.556.832-.602 0-1.985-.792-3.07-.792C2.384 4.388 0 6.14 0 9.703c0 1.053.193 2.14.579 3.263.514 1.474 2.37 5.09 4.307 5.03 1.012-.024 1.727-.72 3.045-.72 1.278 0 1.94.72 3.07.72 1.953-.028 3.632-3.315 4.122-4.793-2.62-1.234-2.479-3.616-2.479-3.693ZM10.37 2.913c1.097-1.302.997-2.487.964-2.913-.968.056-2.089.659-2.728 1.402-.703.796-1.117 1.78-1.028 2.89 1.048.08 2.005-.459 2.792-1.379Z"/>
    </svg>
);
AppleIcon.displayName = 'AppleIcon';
export default AppleIcon;
